import React from 'react';

import styled, { css } from 'styled-components';

import { ProductCategoryTree as BaseProductCategoryTree } from '~/techstyle-shared/react-components';

const CategoryTree = styled(BaseProductCategoryTree)`
  ${({ theme }) => theme.gridStyles.categoryTree}
`;

const getActiveCategoryStyle = (props) => {
  if (props.isActive) {
    return css`
      ${props.theme.gridStyles.activeCategoryItemStyle};
    `;
  }
};

const categoryListStyle = css`
  &&& {
    padding-top: 0;
  }
  & & {
    padding-left: 0;
  }

  & & & {
    padding-left: 16px;
  }
  line-height: 2.86;
`;

const categoryLinkStyle = css`
  ${({ theme }) => theme.gridStyles.categoryItemStyle}
  ${getActiveCategoryStyle};
`;

const categoryItemStyle = css`
  ${({ theme }) => theme.gridStyles.categoryItemStyle}
  padding: 0;
  margin-bottom: 16px;
`;

function ProductCategoryTree(props) {
  return (
    <CategoryTree
      activeCategoryChecker={(category) => category.urlPath}
      categoryListStyle={categoryListStyle}
      categoryLinkStyle={categoryLinkStyle}
      categoryItemStyle={categoryItemStyle}
      {...props}
    />
  );
}

export default ProductCategoryTree;
